/* eslint-disable react/prop-types */
import classNames from 'classnames'

const Grid = ({ children, variant = [], className }) => (
  <div className={classNames('grid', className, ...variant)}> {children}</div>
)

export default Grid
